import { AppVisibility } from '../../interfaces/appVisibility';

/** @deprecated old estateDocuments structure - DON'T USE */
enum EstateFilesType {
  DOCUMENTS = 'DOCUMENTS',
  FORMS = 'FORMS'
}
export enum EstateType {
  COMMUNITY = 'COMMUNITY',
  PRS = 'PRS'
}

export interface EstateData {
  id: string;
  name: string; // short name functioning as display name
  type: EstateType;
  companyId: string | null;
  activePolls: number;
  activeResolutions: number;
  totalShares: number;
  registrationDynamicLink?: string;
  hidden?: true;
  /** Use Archicom Collection App  instead of Fliko App */
  acApp?: true;
}

/**
 * Estate settings that are influencing scheduled functions
 */
export interface EstateDbSettingsData {
  id: string;
  sapEnabled?: true;
  mieszczaninEnabled?: true;
  sonitumEnabled?: true;
  sonitumFakeSuccessEnabled?: true | null;
  welesEnabled?: true;
  welesKeyType?: string;
  rogerEnabled?: true;
  webconEnabled?: true;
  threeCXEnabled?: true;
  /** Returns sample payment schedules and history on staging and RC only. */
  webconPaymentsFakeDataEnabled?: true | null;
}

/** @deprecated old estateDocuments structure - DON'T USE */
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface EstateFile extends AppVisibility {
  name: string;
  id: string;
  estateId: string;
  fileUrl: string;
  position: number;
  showTenants: boolean;
  color?: string;
  fileName?: string;
  type?: EstateFilesType;
}

export interface CustomCurrency {
  balance: string;
  rent: string;
  serviceCharge: string;
  deposit: string;
}
